import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=2b153c2b&"
import script from "./AppDrawer.vue?vue&type=script&lang=js&"
export * from "./AppDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports